import { memo, useEffect } from "react";
import { Badge, Collapse } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import Menu from "../../Menu.js";
import { setCollapse } from "../../store/sidebar";

function Sidebar() {
  let location = useLocation();
  const dispatch = useDispatch();
  const collapse = useSelector((state) => state?.sidebarReducer?.collapse);

  useEffect(() => {
    dispatch(setCollapse({}));
    let newcollapse = JSON.parse(JSON.stringify(collapse || {}));
    
    Menu.filter(({ heading }) => !heading).forEach((item) => {
      const subItems = item.submenu || item.children;
      if (subItems) {
        newcollapse[item.name] = routeActive(subItems.map(({ path }) => path));
      } else {
        newcollapse[item.name] = routeActive(item.path);
      }
    });
    
    dispatch(setCollapse(newcollapse));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]); // Re-run when route changes to keep active state synced

  const SidebarItemHeader = ({ item }) => {
    return (
      <li className="nav-heading">
        <span>{item.heading}</span>
      </li>
    );
  };

  const SidebarItem = ({ item, isActive }) => {
    return (
      <li className={isActive ? "active" : ""}>
        <Link to={item.path} title={item.name}>
          {item.label && (
            <Badge tag="div" className="float-right" color={item.label.color}>
              {item.label.value}
            </Badge>
          )}
          {item.icon && <item.icon className="mr-3" size={18} />}
          <span className="align-middle">{item.name}</span>
        </Link>
      </li>
    );
  };

const SidebarSubItem = ({ item, isActive, handler, children, isOpen }) => {
    return (
      <li className={isActive || isOpen ? "active" : ""}>
        <div 
            className="nav-item d-flex justify-content-between align-items-center w-100 pr-3" 
            onClick={handler} 
            style={{ cursor: "pointer" }}
        >
          <div>
            {item.icon && <item.icon className="mr-3" size={18} />}
            <span className="align-middle">{item.name}</span>
          </div>
          {/* Dropdown Arrow Indicator */}
          <i className={`fas fa-angle-${isOpen ? "down" : "right"} text-muted small`}></i>
        </div>
        
        <Collapse in={isOpen}>
          <ul className="sidebar-nav sidebar-subnav list-unstyled pb-2 m-0" style={{ paddingLeft: '10px' }}>
            {children}
          </ul>
        </Collapse>
      </li>
    );
  };
  const itemType = (item) => {
    if (item.heading) return "heading";
    if (item.submenu || item.children) return "submenu"; // Supports both 'children' and 'submenu' keys
    return "menu";
  };

  const routeActive = (paths) => {
    paths = Array.isArray(paths) ? paths : [paths];
    return paths.some((p) => location.pathname === p);
  };

  const toggleItemCollapse = (stateName) => {
    let newcollapse = JSON.parse(JSON.stringify(collapse || {}));

    // Accordion effect: Close all others
    for (let c in newcollapse) {
      if (newcollapse[c] === true && c !== stateName) {
        newcollapse[c] = false;
      }
    }

    newcollapse[stateName] = !newcollapse[stateName];
    dispatch(setCollapse(newcollapse));
  };

  const getSubRoutes = (item) => {
      const subItems = item.submenu || item.children;
      return subItems.map(({ path }) => path);
  };

  return (
    <>
      <aside className="aside-container">
        <div className="aside-inner">
          <nav data-sidebar-anyclick-close="" className="sidebar">
            <ul className="sidebar-nav">
              <li className="has-user-block"></li>

              {Menu.map((item, i) => {
                if (itemType(item) === "heading") {
                  return <SidebarItemHeader item={item} key={`heading-${i}`} />;
                } 
                
                if (itemType(item) === "menu") {
                  return (
                    <SidebarItem
                      isActive={routeActive(item.path)}
                      item={item}
                      key={`menu-${i}`}
                    />
                  );
                } 
                
                if (itemType(item) === "submenu") {
                  const subItemsArray = item.submenu || item.children;
                  return (
                    <SidebarSubItem
                      item={item}
                      isOpen={collapse?.[item.name] || false}
                      handler={() => toggleItemCollapse(item.name)}
                      isActive={routeActive(getSubRoutes(item))}
                      key={`submenu-${i}`}
                    >
                      {/* Loop through the nested items and render them */}
                      {subItemsArray.map((subitem, j) => (
                        <SidebarItem
                          key={`subitem-${i}-${j}`}
                          item={subitem}
                          isActive={routeActive(subitem.path)}
                        />
                      ))}
                    </SidebarSubItem>
                  );
                }
                
                return null;
              })}
            </ul>
          </nav>
        </div>
      </aside>
    </>
  );
}

export default memo(Sidebar);